import { render, staticRenderFns } from "./tablaConsecutivo.vue?vue&type=template&id=fb49fd34&"
import script from "./tablaConsecutivo.vue?vue&type=script&lang=js&"
export * from "./tablaConsecutivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports